import React from 'react';

const IconLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" id="_圖層_2" viewBox="0 0 267.8 151.49">
    <defs>
      <style>{`.cls-1{fill: #9ebca0;}.cls-2{fill: #789778;}.cls-3{fill: #79837a;}.cls-4{fill: #f7e877;}`}
      </style>
    </defs>
    <g id="_圖層_1-2"><ellipse class="cls-4" cx="102.31" cy="21.46" rx="21.41" ry="21.35"/><path class="cls-3" d="M164.15,2.56l-64.64,58.77,73.98,68.12c15.39,14.17,35.57,22.04,56.53,22.04h37.79L179.19,4.75c-3.2-5.3-10.46-6.35-15.04-2.19Z"/><path class="cls-1" d="M78.89,42.34c-4.59-4.23-11.92-3.16-15.11,2.19L0,151.49h.34L99.51,61.33l-20.62-18.99Z"/><path class="cls-2" d="M.34,151.49h162.39c12.35,0,18.28-15.12,9.21-23.47L99.51,61.33.34,151.49Z"/></g>
  </svg>
);

export default IconLogo;
